import { Action, createAction } from '@ngrx/store';
import { HttpError, PointsAccount } from '@rd/types';

export enum PointsAccountActionTypes {
  LOAD_POINTS_ACCOUNTS = '[PointsAccounts] Load points accounts',
  LOAD_POINTS_ACCOUNTS_SUCCESS = '[PointsAccounts] Load points accounts Success',
  LOAD_POINTS_ACCOUNTS_FAIL = '[PointsAccounts] Load points accounts Fail',
}

export interface LoadPointsAccountsPayload {
  includeClosingPointsAccounts: boolean;
}

export class LoadPointsAccounts implements Action {
  readonly type = PointsAccountActionTypes.LOAD_POINTS_ACCOUNTS;

  constructor(public payload: LoadPointsAccountsPayload) {}
}

export class LoadPointsAccountsSuccess implements Action {
  readonly type = PointsAccountActionTypes.LOAD_POINTS_ACCOUNTS_SUCCESS;

  constructor(public payload: PointsAccount[]) {}
}

export class LoadPointsAccountsFail implements Action {
  readonly type = PointsAccountActionTypes.LOAD_POINTS_ACCOUNTS_FAIL;

  constructor(public payload: HttpError) {}
}

export const NoopPointsAccountSelectionEnded = createAction(
  '[PointsAccounts] No-op: points account selection ended ',
);

export type PointsAccountActions =
  | LoadPointsAccounts
  | LoadPointsAccountsSuccess
  | LoadPointsAccountsFail;
